import FeaturesContainer from './FeaturesContainer';
import useImagesSrc from '../../helper/useImagesSrc';

const FindLoved = ({ history, onePage }) => (
  <FeaturesContainer
    history={history}
    onePage={onePage}
    title={'find_loved'}
    adaptiveHeight={820}
    eventName={'onboardingAr'}
    nextPage={'/flight-status'}
    imagePreload={useImagesSrc().imagesSources.flightStatus}
    imageName={'FindLoved'}
    imageAlt={'Find loved ones via AR'}
  />
);

export default FindLoved
